// extracted by mini-css-extract-plugin
export default {"styledCheckbox":"Checkbox-module--styled-checkbox--0d8eb"};